// Konfigurasi global Sloto69 — ganti URL & kontak di sini saja.
export const SITE = {
  name: "Sloto69",
  tagline: "Pusat Informasi Resmi Sloto69",
  domain: "sloto69gesit.com",
  baseUrl: "https://sloto69gesit.com",

  // Ganti URL berikut dengan link resmi Anda.
  loginUrl: "https://slapet.me/sloto69",
  registerUrl: "https://slapet.me/sloto69daftar",
  alternativeUrl: "#link-alternatif",

  // Kontak (placeholder dummy — silakan ganti).
  whatsappNumber: "6282132650181", // tanpa simbol +
  whatsappMessage: "Halo Sloto69, saya butuh bantuan informasi.",
  telegramUsername: "sloto69_official",
  facebookUrl: "https://www.facebook.com/groups/sloto69official",
};

export const waLink = (() => {
  const text = encodeURIComponent(SITE.whatsappMessage);
  return `https://api.whatsapp.com/send?phone=${SITE.whatsappNumber}&text=${text}`;
})();

export const telegramLink = `https://t.me/${SITE.telegramUsername}`;
export const facebookLink = SITE.facebookUrl;

export const NAV_ITEMS = [
  { label: "Beranda", to: "/" },
  { label: "Tentang", to: "/tentang" },
  { label: "Panduan Login", to: "/panduan-login" },
  { label: "Panduan Daftar", to: "/panduan-daftar" },
  { label: "Link Alternatif", to: "/link-alternatif" },
  { label: "Keamanan", to: "/keamanan" },
  { label: "Artikel", to: "/artikel" },
  { label: "FAQ", to: "/faq" },
  { label: "Kontak", to: "/kontak" },
];

export const ASSETS = {
  logo: "/logo.png",
  favicon: "/favicon.ico",
  ogImage: "/og-image.svg",
  hero: "https://static.prod-images.emergentagent.com/jobs/c8c03896-8991-4c24-a4f9-4238e4a8c963/images/bed2ebe08138d560a0abff54fbecc395bc4be5d019c7e880f7901e5a2064848a.png",
  dashboard: "https://static.prod-images.emergentagent.com/jobs/c8c03896-8991-4c24-a4f9-4238e4a8c963/images/432967021b31f0153b109befbaca45c0196faf948ac7f5f09c33109b3db3ab29.png",
  security: "https://static.prod-images.emergentagent.com/jobs/c8c03896-8991-4c24-a4f9-4238e4a8c963/images/d79bcb4598d256766348276573b80c1855d2ce4aa32760e5db46f8cc91f98918.png",
  wave: "https://static.prod-images.emergentagent.com/jobs/c8c03896-8991-4c24-a4f9-4238e4a8c963/images/0b60ffcfe28cfe80f1fc19f382d885cab340ed85c6d93f4d25b99447a89e9ffc.png",
};
